import React, { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import block from 'bem-cn';

import { actions as promoActions } from 'features/PromoList';

import Basket from 'components/Basket';
import Header from 'components/Header';
import Subheader from 'components/Subheader';
import GameView from 'components/GameView';
import { EditUser } from 'features/Auth';
import { History } from 'features/History';
import { Jackpot } from 'features/Jackpot';
import { MegaWins } from 'features/MegaWins';
import { Promo } from 'features/PromoList';
// import { NewYear } from 'features/NewYear';

import './Game.scss';

const Game = () => {
  const b = block('game');
  const dispatch = useDispatch();
  const platform = useSelector(state => state.auth.platform);
  const { isHideMenu } = useSelector(state => state.game);

  const [isOpenHistory, changeIsOpenHistory] = useState(false);
  const [isClosingHistory, changeIsClosingHistory] = useState(false);
  const switchIsOpenHistory = useCallback(() => {
    if (isOpenHistory) {
      changeIsClosingHistory(true)
      setTimeout(() => changeIsOpenHistory(!isOpenHistory), 700)
    } else {
      changeIsClosingHistory(false)
      changeIsOpenHistory(!isOpenHistory)
    }
  }, [isOpenHistory])
  const [canvasParam, setCanvasParam] = useState({ width: 0, height: 0, });
  const canvasParentRef = useCallback((elem) => {
    if (!elem) return;
    const rect = elem.getBoundingClientRect();
    setCanvasParam({ width: rect.width, height: rect.height });
  }, [])

  useEffect(() => {
    dispatch(promoActions.getPromoList());
  }, [dispatch]);

  // User edit animation
  const [isOpenEdit, changeIsOpenEdit] = useState(false);
  const switchIsOpenEdit = useCallback(() => {
    changeIsOpenEdit(!isOpenEdit)
  }, [isOpenEdit])

  return <article className={b({ platform })}>
    {platform === 'mobile' ? <React.Fragment>
      <div className={b('header-layout', { isOpenHistory: isOpenHistory || isOpenEdit })}>
        <Header switchIsOpenHistory={switchIsOpenHistory} switchIsOpenEdit={switchIsOpenEdit} />
      </div>
      {isOpenHistory && <History isClosingHistory={isClosingHistory} />}
      {isOpenEdit && <EditUser switchIsOpenEdit={switchIsOpenEdit} />}
      <div className={b('scroll-block')}>
        <div className={b('subheader-layout')}>
          <Subheader />
        </div>
        <Jackpot isOnlyModal />
        <article ref={canvasParentRef} className={b('game-view')}>
          <GameView canvasParam={canvasParam} />
        </article>
        <article className={b('content-layout')}>
          <Basket />
        </article>
      </div>
      <MegaWins />
      <Promo />
      {/* <NewYear /> */}
    </React.Fragment> : isHideMenu ? <React.Fragment>
      <div ref={canvasParentRef} className={b('game-view', {isCentered: isHideMenu})}>
        <GameView canvasParam={canvasParam} />
      </div>
      <div className={b('basket-layout', {isCentered: isHideMenu})}>
        <Basket />
      </div>
      <div className={b('subheader-layout', {isCentered: isHideMenu})}>
        <Subheader />
      </div>
      <MegaWins />
      {/* <NewYear /> */}
    </React.Fragment> : <React.Fragment>
      <div className={b('desktop-header-layout')}>
        <Header switchIsOpenHistory={switchIsOpenHistory} switchIsOpenEdit={switchIsOpenEdit} />
        {isOpenEdit && <EditUser switchIsOpenEdit={switchIsOpenEdit} />}
      </div>
      <div ref={canvasParentRef} className={b('game-view')}>
        <GameView canvasParam={canvasParam} />
      </div>
      <div className={b('basket-layout')}>
        <Basket />
      </div>
      <div className={b('subheader-layout')}>
        <Subheader />
      </div>
      <div className={b('history-layout')}>
        <Jackpot />
        <History />
      </div>
      <MegaWins />
      <Promo />
      {/* <NewYear /> */}
    </React.Fragment>}
  </article>
}

export default Game;